import { Injectable, NgModule } from '@angular/core';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
class BlobService {
    /**
     * @param {?} http
     */
    constructor(http) {
        this.http = http;
    }
    /**
     * @param {?} params
     * @param {?} filename
     * @param {?=} useAzureStorageEmulator
     * @param {?=} azureStorageEmulatorBaseUrl
     * @return {?}
     */
    generateBlobUrl(params, filename, useAzureStorageEmulator = false, azureStorageEmulatorBaseUrl = '') {
        /** @type {?} */
        const url = useAzureStorageEmulator ? azureStorageEmulatorBaseUrl : `https://${params.storageAccount}.blob.core.windows.net`;
        return `${url}/${params.containerName}/${filename}`;
    }
    /**
     * @param {?} reader
     * @param {?} state
     * @return {?}
     */
    uploadFileInBlocks(reader, state) {
        if (!state.cancelled) {
            if (state.totalBytesRemaining > 0) {
                /** @type {?} */
                const fileContent = state.file.slice(state.currentFilePointer, state.currentFilePointer + state.maxBlockSize);
                /** @type {?} */
                const blockId = state.blockIdPrefix + this.prependZeros(state.blockIds.length, 6);
                state.blockIds.push(btoa(blockId));
                reader.readAsArrayBuffer(fileContent);
                state.currentFilePointer += state.maxBlockSize;
                state.totalBytesRemaining -= state.maxBlockSize;
                if (state.totalBytesRemaining < state.maxBlockSize) {
                    state.maxBlockSize = state.totalBytesRemaining;
                }
            }
            else {
                this.commitBlockList(state);
            }
        }
    }
    /**
     * @param {?} state
     * @return {?}
     */
    commitBlockList(state) {
        /** @type {?} */
        const uri = state.fileUrl + '&comp=blocklist';
        /** @type {?} */
        const headers = new HttpHeaders({ 'x-ms-blob-content-type': state.file.type });
        /** @type {?} */
        let requestBody = '<?xml version=\'1.0\' encoding=\'utf-8\'?><BlockList>';
        for (let i = 0; i < state.blockIds.length; i++) {
            requestBody += '<Latest>' + state.blockIds[i] + '</Latest>';
        }
        requestBody += '</BlockList>';
        this.http.put(uri, requestBody, { headers: headers, responseType: 'text' })
            .subscribe(_elem => {
            if (state.complete) {
                state.complete();
            }
        }, err => {
            console.log({ error: err });
            if (state.error) {
                state.error(err);
            }
        });
    }
    /**
     * @param {?} config
     * @return {?}
     */
    initializeState(config) {
        /** @type {?} */
        let blockSize = BlobService.DefaultBlockSize;
        if (config.blockSize) {
            blockSize = config.blockSize;
        }
        /** @type {?} */
        let maxBlockSize = blockSize;
        /** @type {?} */
        let numberOfBlocks = 1;
        /** @type {?} */
        const file = config.file;
        /** @type {?} */
        const fileSize = file.size;
        if (fileSize < blockSize) {
            maxBlockSize = fileSize;
        }
        if (fileSize % maxBlockSize === 0) {
            numberOfBlocks = fileSize / maxBlockSize;
        }
        else {
            numberOfBlocks = fileSize / maxBlockSize + 1;
        }
        return {
            maxBlockSize: maxBlockSize,
            // Each file will be split in 256 KB.
            numberOfBlocks: numberOfBlocks,
            totalBytesRemaining: fileSize,
            currentFilePointer: 0,
            blockIds: new Array(),
            blockIdPrefix: 'block-',
            bytesUploaded: 0,
            submitUri: null,
            file: file,
            baseUrl: config.baseUrl,
            sasToken: config.sasToken,
            fileUrl: config.baseUrl + config.sasToken,
            progress: config.progress,
            complete: config.complete,
            error: config.error,
            cancelled: false
        };
    }
    /**
     * @param {?} config
     * @return {?}
     */
    upload(config) {
        /** @type {?} */
        const state = this.initializeState(config);
        /** @type {?} */
        const reader = new FileReader();
        reader.onloadend = (evt) => {
            if (evt.target.readyState === 2 && !state.cancelled) {
                /** @type {?} */
                const uri = state.fileUrl + '&comp=block&blockid=' + state.blockIds[state.blockIds.length - 1];
                /** @type {?} */
                const requestData = evt.target.result;
                /** @type {?} */
                const requestData2 = new Uint8Array(evt.target.result);
                /** @type {?} */
                const headers = new HttpHeaders({ 'x-ms-blob-type': 'BlockBlob', 'Content-Type': 'application/octet-stream' });
                this.http.put(uri, requestData, { headers: headers, responseType: 'text' })
                    .subscribe(_elem => {
                    state.bytesUploaded += requestData2.length;
                    /** @type {?} */
                    const percentComplete = Math.round((state.bytesUploaded / state.file.size) * 1000) / 10;
                    if (state.progress) {
                        state.progress(percentComplete);
                    }
                    this.uploadFileInBlocks(reader, state);
                }, err => {
                    console.log({ error: err });
                    if (state.error) {
                        state.error(err);
                    }
                });
            }
        };
        this.uploadFileInBlocks(reader, state);
        return {
            cancel: () => {
                state.cancelled = true;
            }
        };
    }
    /**
     * @param {?} number
     * @param {?} length
     * @return {?}
     */
    prependZeros(number, length) {
        /** @type {?} */
        let str = '' + number;
        while (str.length < length) {
            str = '0' + str;
        }
        return str;
    }
}
BlobService.ɵfac = function BlobService_Factory(t) { return new (t || BlobService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
BlobService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: BlobService, factory: BlobService.ɵfac });
BlobService.DefaultBlockSize = 1024 * 32;
/** @nocollapse */
BlobService.ctorParameters = () => [
    { type: HttpClient }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BlobService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class BlobModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: BlobModule,
            providers: [
                BlobService
            ]
        };
    }
}
BlobModule.ɵfac = function BlobModule_Factory(t) { return new (t || BlobModule)(); };
BlobModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: BlobModule });
BlobModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        HttpClientModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BlobModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    HttpClientModule
                ],
                declarations: [],
                exports: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BlobModule, { imports: function () { return [CommonModule,
        HttpClientModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { BlobService, BlobModule };

